import React from 'react';
import './stepper.css';

interface StepperProps {
  totalSteps: number;
  currentStep: number;
  variant?: 'default' | 'primary' | 'secondary' | 'tertiary';
}

export const Stepper: React.FC<StepperProps> = ({ 
  totalSteps, 
  currentStep, 
  variant = 'default' 
}) => {
  // Create an array of steps from 1 to totalSteps
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  return (
    <div className={`stepper-container stepper-${variant}`}>
      {steps.map((step) => {
        // Determine the status of each step
        const isActive = step === currentStep;
        const isCompleted = step < currentStep;
        const isPending = step > currentStep;
        
        // Create the class name based on the step status
        const stepClassName = `stepper-step ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''} ${isPending ? 'pending' : ''}`;
        const lineClassName = `stepper-line ${isCompleted ? 'completed' : ''}`;
        
        return (
          <div key={step} className="stepper-item">
            <div className={stepClassName}>
              <span>{step}</span>
            </div>
            
            {/* Don't render a line after the last step */}
            {step < totalSteps && (
              <div className={lineClassName}></div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
